module.exports = __webpack_public_path__ + "fb49e0dfed3f3828db4081ea039a750d.png";